function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h138v116H.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 58.5,
  r: 4,
  transform: "rotate(90 10.5 58.5)"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M14.5 58.5h-8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128.5,
  cy: 58.5,
  r: 4,
  transform: "rotate(90 128.5 58.5)"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M132.5 58.5h-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.5 64.5h5v39h-5zm-44 0h5v39h-5zm55 0h5v39h-5zm-44 0h5v39h-5zm55 0h5v39h-5zm-44 0h5v39h-5zm55 0h5v39h-5zm-44 0h5v39h-5zm11-51h5v39h-5zm-44 0h5v39h-5zm55 0h5v39h-5zm-44 0h5v39h-5zm55 0h5v39h-5zm-44 0h5v39h-5zm55 0h5v39h-5zm-44 0h5v39h-5zm57 26h7v14h-7zm2-.283V27.5h3v11.717m-3 14.283v36.123h3V53.5"
}));

function SvgRoomVentLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 117,
    viewBox: "0 0 139 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomVentLarge);
export default __webpack_public_path__ + "static/media/RoomVentLarge.2dfd28bf.svg";
export { ForwardRef as ReactComponent };